import { notification } from 'antd';

// types: success, error, info
export const openNotification = (type, message, description) => {
  notification[type]({
    message,
    description,
  });
};